import React, { createContext, useState, useEffect, useContext } from 'react';
import APIHelper from '../axios/apiHelper'

const StateContext = createContext();

export const useStateContext = () => {
    const context = useContext(StateContext);
    if (!context) {
        throw new Error("useStateContext must be used within a stateProvider");
    }
    return context;
}

export const StateProvider = ({ children }) => {
    const [states, setStates] = useState([])

    const getStateById = id => {
        return states.find(state => state._id === id)
    }

    const getStateNameById = id => {
        return states.find(state => state._id === id)?.name
    }

    const getStateIdByName = name => {
        return states.find(state => state.name.toLowerCase() === name.toLowerCase())?._id
    }

    useEffect(() => {
        APIHelper.fetchLookUp('state')
            .then(({ data }) => setStates(data.payload))
            .catch(e => console.error(e))
    }, [])

    return (
        <>
            <StateContext.Provider value={{ 
                states,
                getStateById,
                getStateNameById,
                getStateIdByName
            }}>
                {children}
            </StateContext.Provider>
        </>
    );
};
